module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/twitter-410fcea7d94446a75eff73d9a131dd74.svg";